import {translate, Text, localeFont} from './utils';
import common from './common';

export default class ConfirmDialog extends PIXI.Container {
    constructor(text) {
        super();
        this._approveButton = null;
        this._cancelButton = null;
        this._text = text;
        this.signals = {
            confirm: new P3.utils.MiniSignal(),
            deny: new P3.utils.MiniSignal()
        };

        this.init();
    }

    init() {
        const bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.tint = 0x0;
        bg.width = common.STAGE_WIDTH;
        bg.height = common.STAGE_HEIGHT * 2;
        bg.anchor.set(0.5);
        bg.alpha = 0.2;
        // interaction blocker
        //bg.beginFill(0xFF0000, 0);
        ///bg.drawRect(-common.STAGE_WIDTH, common.STAGE_HEIGHT * -0.5, common.STAGE_WIDTH * 2, common.STAGE_HEIGHT * 2);
        ///	bg.endFill();
        bg.interactive = true;
        this.addChild(bg);

        let warningbg = new PIXI.Sprite(P3.assets.texture('undo_warning'));
        warningbg.anchor.set(0.5);
        this.addChild(warningbg);

        let label = new PIXI.Text(this._text, {
            fontSize: 26,
            fontFamily: localeFont(),
            align: 'center',
            colour: 0x07485B
        });
        label.maxWidth = 420;
        label.anchor.set(0.5);
        label.position.x += 60;
        this.addChild(label);

        if (label.height > 54) {
            label.height = 54;
            label.scale.x = label.scale.y;
        }

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_ter_yes_out');

        this._approveButton = new P3.Button(states);
        this._approveButton.signals.click.add(() => {
            this.signals.confirm.dispatch();
        }, this);
        this._approveButton.position.set(100, 75);
        this.addChild(this._approveButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');
        states.icon = P3.assets.texture('icon_ter_no_red_out');

        this._cancelButton = new P3.Button(states);
        this._cancelButton.signals.click.add(() => {
            this.signals.deny.dispatch();
        }, this);
        this._cancelButton.position.set(-15, 75);
        this.addChild(this._cancelButton);
    }

    destroy() {
        super.destroy();
    }
}
